<template>
    <div class="container">
        <b-row v-if="!isLoading">
	<b-container>
		<md-table v-model="listRazones" md-card md-fixed-header @md-selected="f_muestra">
		<md-table-toolbar>
			<h1 class="md-title"><b><i>{{labels.title}}</i></b></h1>
			<md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="f_adicione_razon()">
					<md-icon>add</md-icon>
				</md-button>
			</md-table-toolbar>
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
				<md-table-cell :md-label="labels.razon" class="text-center border">{{item.razon}}</md-table-cell>
				<md-table-cell :md-label="labels.descripcion" class="text-left border">{{item.descripcion}}</md-table-cell>
				<md-table-cell :md-label="labels.estado" class="text-left border">{{f_estado(item.estado)}}</md-table-cell>
			</md-table-row>
			</md-table>
	</b-container>
	<md-dialog :md-active.sync="adicioneRazon">
		<md-dialog-title class="text-center">
			<h3><b><i>{{labels.title}}</i></b></h3>
		</md-dialog-title>
		<md-dialog-content>
			<md-table>
				<md-table-row>
					<md-table-cell>Razon</md-table-cell>
					<md-table-cell>
						<md-input v-model="form.razon" @input="f_verifique_elimina()"></md-input>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell>Descripcion</md-table-cell>
					<md-table-cell>
						<md-input v-model="form.descripcion" @input="f_verifique_elimina()"></md-input>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell>Estado</md-table-cell>
					<md-table-cell>
						<select v-model="form.estado" class="form-control">
							<option v-for="estado in listEstados" :value="estado.estado" :key="estado.id">{{estado.estado}}-{{estado.descripcion}}</option>
						</select>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<md-dialog-actions>
				<md-button v-if="fgl_elimina" class="md-accent" @click="f_borraRazon()">Eliminar</md-button>
				<md-button class="md-accent" @click="f_grabaRazon()">Grabar</md-button>
				<md-button class="md-accent" @click="adicioneRazon=false">Cerrar</md-button>
			</md-dialog-actions>
		</md-dialog-content>
	</md-dialog>
        </b-row>
    </div>
</template>
<script>
import Razon from "@/services/Razones"
import Estado from "@/services/Estados"

export default {
    name:'Razones',
    data: () => ({
        isLoading: false,
	fgl_elimina: true,
        listRazones : [],
        listEstados : [],
	form : {
		id: '',
		razon: '',
		descripcion:'',
		estado:'',
		idUser:'',
	},
	formelimina : {
		id: '',
		razon: '',
		descripcion:'',
		estado:'',
		idUser:'',
	},
	adicioneRazon: false,
	razon : '',
	descripcion : '',
	estado : '',

    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : "Razones",
                    razon : "Razon",
                    descripcion : "Descripcion",
                    estado : "Estado",
                }
            }else{
                return {
                    title : "Reazon",
                    razon : "Reason",
                    descripcion : "Description",
                    estado : "State",
                }
            }
        }
    },
    mounted(){
        Razon.leaRazones()
        .then((res) => {
            this.listRazones = res.data.listRazones
        })
        .catch((err) => {
            console.log(err)
        })
        Estado.leaEstados()
        .then((res) => {
            this.listEstados = res.data.listEstados
        })
        .catch((err) => {
            console.log(err)
        })
    },
    methods:{
	f_estado(estado) {
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado == estado)
		if	(v_estado == undefined || v_estado == null) {
			return estado
		}
		return v_estado.descripcion
	},
	f_adicione_razon() {
		this.form.id=-1
		this.form.razon=''
		this.form.descripcion=''
		this.form.estado=''
		this.adicioneRazon=true
		this.fgl_elimina = false
	},
	f_muestra(r_razon) {
		this.form.razon = r_razon.razon
		this.form.descripcion = r_razon.descripcion
		this.form.estado = r_razon.estado
		this.form.id = r_razon.id
		this.adicioneRazon=true
		const v_razon = this.form.razon
		const v_descripcion = this.form.descripcion
		const v_estado = this.form.estado
		this.formelimina.razon = v_razon
		this.formelimina.descripcion = v_descripcion
		this.formelimina.estado = v_estado
		this.fgl_elimina = true
	},
	f_grabaRazon() {
		
		if	(this.form.razon == '') {
			this.$toast.error("Razon no puede estar vacia")
			return
		}
		if	(this.form.descripcion == '') {
			this.$toast.error("Descripcion no puede estar vacia")
			return
		}
		if	(this.form.estado == '') {
			this.$toast.error("Estado no puede estar vacio")
			return
		}
		const v_razon = this.listRazones.find((r_razon) => r_razon.razon == this.form.razon)
		this.form.idUser = this.$store.state.userId
		if	(v_razon === undefined) {
			Razon.grabaRazon(this.form)
			.then((res) => {
				if	(res.status == 200){
					this.$toast.success("Informacion Grabada correctamente")
					setTimeout(() => {
						Razon.leaRazones()
						.then((res) => {
							this.listRazones= res.data.listRazones
						})
						.catch((err) => {
							console.log(err)
						})
					},1000)
				} else {
					this.$toast.error(res.data.message+" al grabar razones")
				}
			})
			.catch((err) => {
				console.log(err)
			})
		} else {
			if	(this.form.id !== -1) {
				Razon.actualizaRazon(this.form)
				.then((res) => {
					if	(res.status == 200){
						this.$toast.success("Informacion Grabada correctamente")
						setTimeout(() => {
							Razon.leaRazones()
							.then((res) => {
								this.listRazones= res.data.listRazones
							})
							.catch((err) => {
								console.log(err)
							})
						},1000)
					} else {
						this.$toast.error(res.data.message+" al grabar razones")
					}
				})
				.catch((err) => {
					console.log(err)
				})
			} else {
				this.$toast.error("Razon ya definida")
			}
			this.adicioneRazon = false
		}
		Razon.leaRazones()
		.then((res) => {
			this.listRazones = res.data.listRazones
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_verifique_elimina() {
		if	(this.formelimina.razon != this.form.razon ||
			this.formelimina.descripcion != this.form.descripcion ||
			this.formelimina.estado != this.form.estado) {
			this.fgl_elimina=false
		} else {
			this.fgl_elimina=true
		}
	},
	f_borraRazon() {
		Razon.borraRazon(this.form.id)
		.then((res) => {
			if	(res.status == 200){
				this.$toast.success("Informacion Borrada correctamente")
				setTimeout(() => {
					Razon.leaRazones()
					.then((res) => {
						this.listRazones= res.data.listRazones
					})
					.catch((err) => {
						console.log(err)
					})
				},1000)
			} else {
				this.$toast.error(res.data.message+" al borrar razones")
			}
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al borrar razones")
		})
		this.adicioneRazon = false
	},
    }
}
</script>

<style>

</style>
